export { default as EntranceOnboardingExamInstructions } from './EntranceOnboardingExamInstructions';
export { default as RejectedOnboardingExamInstructions } from './RejectedOnboardingExamInstructions';
export { default as ErrorOnboardingExamInstructions } from './ErrorOnboardingExamInstructions';
export { default as SubmittedOnboardingExamInstructions } from './SubmittedOnboardingExamInstructions';
export { default as VerifiedOnboardingExamInstructions } from './VerifiedOnboardingExamInstructions';
